import _ from './Trans';

const server = process.env.REACT_APP_PUBLIC_URL
const public_server = process.env.REACT_APP_RESOURCES_URL
let react_server = process.env.REACT_APP_PUBLIC_REACT_URL
const api_path = '/api/v1';

react_server = window.location.protocol + "//" + window.location.hostname;
if(![80, 443].includes(window.location.port)) {
    react_server += ":" + window.location.port;
}

const toastConfig = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
}

const
    GOALKEEPER = 1,
    RIGHT_BACK = 3,
    CENTER_BACK = 2,
    LEFT_BACK = 4,
    RIGHT_WING = 6,
    PIVOT = 5,
    LEFT_WING = 8,
    BENCH = 9,
    MINILEAGUE_STANDARD = 1,
    MINILEAGUE_BROKER = 2,
    MINILEAGUE_GOALS_AND_STOPS = 3,
    MOBILE_MAX_WIDTH = 767;


let noPlayerImage = 'https://asobal.es/img/nojugador.jpg';
let emptyPlayerImage = public_server + '/empty_member.png'

let emptyMember = {
    id: null,
    image_link: emptyPlayerImage,
    name: "",
    position: 0,
    position_abbreviation: "",
    last_valuation: null,
    is_captain: false
}

let brokenPlayerImage = 'https://ehfeuro.eurohandball.com/assets/svgs/theme--blue/player-logo-180x225.svg'
let squadApiUrl = server + api_path + '/squad/';
let sellPlayerUrl = server + api_path + '/squad/player/0/';
let revertChangesUrl = server + api_path + "/squad/0/revert_changes/";
let rankingUrl = server + api_path + '/ranking/0/';
let weeklyRankingUrl = server + api_path + '/ranking/0/weekly/';
let addPlayerToSquadUrl = server + api_path + '/squad/player/';
let playerListUrl = server + api_path + '/player/?';
let playersListUrl = server + api_path + '/player/list/';
let playerDetailUrl = server + api_path + '/player/0/?';
let mostValuablePlayersUrl = server + api_path + '/player/most-valuable/';
let sendInviteEmailUrl = server + api_path + '/invite/';
let changePlayerInSquadUrl = server + api_path + '/player-in-squad/0/';
let setCaptainUrl = server + api_path + '/squad/player/captain/0/';
let getTrophiesUrl = server + api_path + '/trophy/';
let setTrophiesUrl = server + api_path + '/trophy/0/';
let lockedTrophyUrl = server + '/static/images/trophies/asobal2425/locked.svg';
let unlockedTrophySoundUrl = server + '/static/sound/trophy.mp3'
let handballCourtUrl = server + '/static/images/handball_court.svg';
let logoutPage = server + '/logout';
let fetchUserUrl = server + api_path + '/user/';
let updatePasswordUrl = server + api_path + '/user/0/password/';
let switchTournamentUrl = server + api_path + '/user/0/tournament/';
let newsUrl = server + api_path + '/news/';
let tournamentTeamsUrl = server + api_path + '/tournament/0/teams/';
let financeUrl = server + api_path + '/squad/0/finance/'
const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
let miniLeagueUrl = server + api_path + '/mini-league/';
let miniLeagueReactUrl = react_server + '/mini-league/';
let signatureSoundUrl = server + '/static/sound/signature.mp3'
let signatureImageUrl = server + '/static/images/signature.png';

const appCustomer = process.env.REACT_APP_CUSTOMER;

/* ASOBAL */
let backgroundAsobalUrl = '';
let logoAsobalUrl = server + '/static/images/asobal/logo.png';
let logoOlympicsUrl = server + '/static/images/olympics/logo.png';
let handballCourtAsobalUrl = server + '/static/images/asobal/handball_court.svg?v=3';
let handballCourtOlympicUrl = server + '/static/images/olympics/handball_court.svg?v=1';
let handballBenchUrl = server + '/static/images/olympics/bench.svg?v=1';
let imgBannerMiddleUrl = server + '/static/images/asobal/banner_middle.png';
let imgBannerMiddleText = "Plenitude - Somos la energía para cambiar";
const GA_CODE = process.env.REACT_APP_GA_TAG;
const CSS = process.env.REACT_APP_PUBLIC_URL + "/static/css/" + appCustomer +".scss?v=1";

if(appCustomer === 'asobal') {
    backgroundAsobalUrl = server + '/static/images/asobal/background.jpg';
    logoAsobalUrl = server + '/static/images/asobal/logo.png';
    handballCourtAsobalUrl = server + '/static/images/asobal/handball_court.svg';
    imgBannerMiddleUrl = server + '/static/images/asobal/banner_middle.png';
    imgBannerMiddleText = "Plenitude - Somos la energía para cambiar";
}

let handballCourtImageUrl = handballCourtUrl;
if(appCustomer !== undefined && appCustomer.toLowerCase() === 'asobal') {
    handballCourtImageUrl = handballCourtAsobalUrl;
}
if(appCustomer !== undefined && appCustomer.toLowerCase() === 'olympic') {
    handballCourtImageUrl = handballCourtOlympicUrl;
}

const MAX_MOBILE_WINDOW_DIMENSION = 576;

const errorMessages = {
    'POSITION_OCCUPIED': _('Position already occupied'),
    'PRICE_EXCEEDS_BUDGET': _('Price exceeds your budget'),
    'MAX_PLAYERS_FROM_A_TEAM_REACHED': _('You have reached max number of players of the same team (3)'),
    'PLAYER_ALREADY_IN_SQUAD': _('Player already in squad'),
    'PLAYER_CANNOT_JOIN': _('Player cannot join team, you must sell another player first'),
    'PLAYER_NOT_FOUND': _('Player not found'),
    'OUT_OF_TRANSFER_WINDOW': _('Out of transfer window'),
    'NOT_YOUR_PLAYER': _('Not your player'),
    'TEAM_DISQUALIFIED': _('Team disqualified'),
    'MAX_TRANSFERS_OUT_REACHED': _('Max transfers out reached'),
    'MAX_TRANSFERS_IN_REACHED': _('Max transfers in reached')
}

const Config = {
    toastConfig: toastConfig,
    noPlayerImage: noPlayerImage,
    emptyPlayerImage: emptyPlayerImage,
    brokenPlayerImage: brokenPlayerImage,
    squadApiUrl: squadApiUrl,
    sellPlayerUrl: sellPlayerUrl,
    revertChangesUrl: revertChangesUrl,
    rankingUrl: rankingUrl,
    weeklyRankingUrl: weeklyRankingUrl,
    addPlayerToSquadUrl: addPlayerToSquadUrl,
    playerListUrl: playerListUrl,
    playersListUrl: playersListUrl,
    playerDetailUrl: playerDetailUrl,
    mostValuablePlayersUrl: mostValuablePlayersUrl,
    sendInviteEmailUrl: sendInviteEmailUrl,
    changePlayerInSquadUrl: changePlayerInSquadUrl,
    setCaptainUrl: setCaptainUrl,
    getTrophiesUrl: getTrophiesUrl,
    setTrophiesUrl: setTrophiesUrl,
    lockedTrophyUrl: lockedTrophyUrl,
    unlockedTrophySoundUrl: unlockedTrophySoundUrl,
    logoutPage: logoutPage,
    fetchUserUrl: fetchUserUrl,
    updatePasswordUrl: updatePasswordUrl,
    switchTournamentUrl: switchTournamentUrl,
    newsUrl: newsUrl,
    tournamentTeamsUrl: tournamentTeamsUrl,
    contactEmail: contactEmail,
    financeUrl: financeUrl,
    miniLeagueUrl: miniLeagueUrl,
    miniLeagueReactUrl: miniLeagueReactUrl,
    signatureSoundUrl: signatureSoundUrl,
    signatureImageUrl: signatureImageUrl,
    backgroundAsobalUrl: backgroundAsobalUrl,
    logoAsobalUrl: logoAsobalUrl,
    logoOlympicsUrl: logoOlympicsUrl,
    handballCourtImageUrl: handballCourtImageUrl,
    handballBenchUrl: handballBenchUrl,
    imgBannerMiddleUrl: imgBannerMiddleUrl,
    imgBannerMiddleText: imgBannerMiddleText,
    appCustomer: appCustomer,
    GA_CODE: GA_CODE,
    MAX_MOBILE_WINDOW_DIMENSION: MAX_MOBILE_WINDOW_DIMENSION,
    GOALKEEPER: GOALKEEPER,
    LEFT_WING: LEFT_WING,
    RIGHT_WING: RIGHT_WING,
    CENTER_BACK: CENTER_BACK,
    LEFT_BACK: LEFT_BACK,
    RIGHT_BACK: RIGHT_BACK,
    PIVOT: PIVOT,
    BENCH: BENCH,
    MINILEAGUE_STANDARD: MINILEAGUE_STANDARD,
    MINILEAGUE_BROKER: MINILEAGUE_BROKER,
    MINILEAGUE_GOALS_AND_STOPS: MINILEAGUE_GOALS_AND_STOPS,
    MOBILE_MAX_WIDTH: MOBILE_MAX_WIDTH,
    errorMessages: errorMessages,
    CSS: CSS,
    emptyMember: emptyMember,
    extraConfig: {
        myAccountEnabled: appCustomer !== 'asobal',
        newsEnabled: appCustomer !== 'asobal'
    }
};

export default Config;